const initState = {
    accountNo: null,
    credentialsexpired: false,
    dp: false,
    email: null,
    enabled: false,
    locked: false,
    id: null,
    mobile: '',
    otp: '',
    roles: [],
    serialNo: '',
    serialNoType: '',
    walletBalance: 0,
    customerData: {},
    customerDataBySerialNo: {},
    storePaymentData: {},
    profile: {
    },
    userInfo: {
    },
    userProfile: {
        customer_NAME: ''
    }
}

export default initState;